import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import CardInfo from '../../components/cardInfo';
import { getWinners } from '../../slices/winnersSlice';
import LoaderCP from '../../components/loader';

const WinnerSection = () => {
  const dispatch = useDispatch();
  const { winners, status } = useSelector((state) => state.winners);

  const [toggleState, setToggleState] = useState('');

  const lastMonthWinnerData = () => {
    let lastMonthWinner;
    if (winners !== []) {
      const indexValue = winners.length - 1;
      const lastMonth = (winners[indexValue]);
      if (lastMonth !== undefined) {
        lastMonthWinner = lastMonth.month;
      }
    }
    return setToggleState(lastMonthWinner);
  };

  useEffect(() => {
    lastMonthWinnerData();
  }, [winners]);

  useEffect(() => {
    dispatch(getWinners());
  }, []);

  const toogleTabs = (numberTab) => {
    setToggleState(numberTab);
  };

  const renderCards = () => {
    return (
      <Container fluid className="bg-white py-60" id="up">
        <Container className="container-tabs">
          <Row className="">
            <Col lg={12} className="text-center bg-white mb-3">
              <h2 className="ft-24 f-600">Ganadores de Subastas anteriores</h2>
            </Col>
          </Row>

          <Row className="justify-content-center pt-15 pb-60">
            <div className="block-tabs">
              {winners.map((w) => (
                <button key={w.month} type="button" onClick={() => toogleTabs(w.month)} className={`f-600 ${toggleState === w.month ? 'tabs active-tabs' : 'tabs'}`}>
                  {w.month}
                </button>
              ))}
            </div>
          </Row>

          <div className="content-tabs">
            {winners.map((w) => (
              <div className={toggleState === w.month ? 'content active-content' : 'content'} key={w.month}>
                <Row>
                  {w.winnersList.map((card) => (
                    <Col xl={3} lg={4} sm={12} xs={12} className="br-5" key={card.auctionInfo.personName}>
                      <Link to={`/subastas/${card.auctionInfo.urlName}/${card.auctionInfo.id}`} className="btn-link">
                        <CardInfo
                          image={card.auctionInfo.imageHome}
                          title={card.auctionInfo.title}
                          winner={card.personName}
                          type="winner" />
                      </Link>
                    </Col>
                  ))}
                </Row>
              </div>
            ))}
          </div>
        </Container>
      </Container>
    );
  };

  return (
    <>
      {status === 'loading' ? <LoaderCP /> : ''}
      {status === 'failed' ? '' : ''}
      {status === 'success' && winners.length > 0 ? renderCards() : ''}
    </>
  );
};

export default WinnerSection;
